"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_1 = require("@app/util/i18n");
const is_defined_1 = require("./is-defined");
function calculatePercentage({ baseValue, currentValue, round = true, }) {
    const percentage = (currentValue / baseValue) * 100;
    if (!Number.isFinite(percentage))
        return 100;
    if (!Number.isNaN(percentage))
        return percentage;
    if (round)
        return Math.round(percentage);
    return 0;
}
function removeZeroBefore(number) {
    if (!(0, is_defined_1.isValue)(number))
        return '';
    if (isNaN(number))
        return '';
    return number.toString().replace(/^(?:0+(?=[1-9])|0+(?=0$))/gm, '');
}
const roundNDecimals = (number, decimals = 2) => {
    if (!(0, is_defined_1.isValue)(number))
        return 0;
    const factor = Math.pow(10, decimals);
    return Math.round(number * factor) / factor;
};
const round2decimals = (number, localize = true) => {
    if (!(0, is_defined_1.isValue)(number))
        return '';
    const roundWith2Decimals = roundNDecimals(number, 2);
    return localize ? localizeNumber(roundWith2Decimals) : roundWith2Decimals;
};
function localizeNumber(number) {
    const userLocale = (0, i18n_1.getLanguage)();
    if (!(0, is_defined_1.isValue)(number))
        return '';
    if (typeof number === 'string') {
        const asNumber = parseFloat(number);
        if (isNaN(asNumber)) {
            return number;
        }
        else {
            return new Intl.NumberFormat(userLocale).format(asNumber);
        }
    }
    return new Intl.NumberFormat(userLocale).format(number);
}
function localizeAsCurrency(number, { currency, currencyDisplay = 'symbol', minimumFractionDigits = 0, locale = (0, i18n_1.getLanguage)(), } = {}) {
    if (!(0, is_defined_1.isValue)(number))
        return '';
    const asNumber = parseFloat(String(number));
    if (isNaN(asNumber))
        return String(number);
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: (0, is_defined_1.isValue)(currency) ? currency : 'CZK',
        currencyDisplay,
        minimumFractionDigits,
    });
    return formatter.format(asNumber);
}
function localizeAsHours(number, { locale = (0, i18n_1.getLanguage)() } = {}) {
    if (!(0, is_defined_1.isValue)(number))
        return '';
    const asNumber = parseFloat(String(number));
    if (isNaN(asNumber))
        return String(number);
    const formatter = new Intl.NumberFormat(locale, {
        style: 'unit',
        unit: 'hour',
        minimumFractionDigits: 0,
    });
    return formatter.format(asNumber);
}
function getCurrencySymbol({ currency, locale = (0, i18n_1.getLanguage)(), } = {}) {
    const PLACEHOLDER_NUMBER = 42;
    const formatter = new Intl.NumberFormat(locale, {
        currency: (0, is_defined_1.isValue)(currency) ? currency : 'CZK',
        style: 'currency',
        currencyDisplay: 'symbol',
    });
    return formatter
        .formatToParts(PLACEHOLDER_NUMBER)
        .find((part) => part.type === 'currency')?.value;
}
exports.default = {
    calculatePercentage,
    round2decimals,
    roundNDecimals,
    localizeNumber,
    localizeAsCurrency,
    localizeAsHours,
    getCurrencySymbol,
    removeZeroBefore,
};
